import placeholder from "../../assets/mk8dx-logo.webp";
import { useState } from "react";
import "./Track.css";
import trackToString from "../../functions/trackToString";

export default function Track(props) {
    const [hover, setHover] = useState(false);
    const pcText = "Select a track below";  // placeholder text for non-selected tracks

    return (
        <li
            className={`prevent-select track-container-${props.size}`}
            role={props.tabIndex === 0 ? "button" : "listitem"}
            tabIndex={props.tabIndex}
            id={`${props.yourCup ? "user" : "display"}-${props.index + 1}`}
            style={{
                cursor: props.showCursor ? "pointer" : "auto",
                backgroundImage: `url(${props.track?.image ? props.track.image : placeholder})`,
            }}
            title={props.track ? trackToString(props.track) : pcText}

            onPointerEnter={() => setHover(true)}
            onPointerLeave={() => setHover(false)}
            onFocus={() => setHover(true)}
            onBlur={() => setHover(false)}

            onClick={() => props.yourCup || props.selectTrack === 5 ? null
                : props.addToCup(props.index)}

            onKeyDown={(e) => {
                if ((e.key === "Enter" || e.key === " ") && !props.yourCup
                    && props.selectTrack !== 5) {
                    e.preventDefault();
                    props.addToCup(props.index);
                }
            }}
        >
            {
                props.showEmblem && <div>
                    <img
                        src={props.track?.emblem}
                        alt={`${props.track?.emblem} Cup Emblem`}
                        className="track-emblem"
                    />
                </div>
            }

            <div className="track-info">
                <p className={`track-origin-${props.size}`}
                    style={{
                        display: props.track?.origin ? "block" : "none",
                        background: (!props.yourCup && hover && props.selectTrack !== 5)
                            || props.select ? "#FFED00" : "white"
                    }}
                >
                    {props.track?.origin}
                </p>

                <p className={`track-name-${props.size}`}
                    style={{
                        background: (!props.yourCup && hover && props.selectTrack !== 5)
                            || props.select ? "#FFED00" : "white"
                    }}>
                    {props.track ? props.track?.name : pcText}
                </p>
            </div>

        </li>
    );
}